<template>
  <div class="iframe-page">
    <section class="panel" v-if="type == '1' || type == '3'">
      <iframe
        class="frame"
        :src="iframeOne"
        title="site-a"
        frameborder="0"
      ></iframe>
    </section>
    <section class="panel" v-if="type == '2' || type == '3'">
      <iframe
        class="frame"
        :src="iframeTwo"
        title="site-b"
        frameborder="0"
        
      ></iframe>
    </section>
    <button
      type="button"
      class="goods-float-button"
      @click="toggleGoodsPanel"
    >
      商品推荐
      <span v-if="goodsList.length" class="goods-float-count">{{ goodsList.length }}</span>
    </button>

    <div
      v-if="goodsPanelVisible"
      class="goods-panel-mask"
      @click="goodsPanelVisible = false"
    >
      <div class="goods-panel" @click.stop>
        <div class="goods-panel-header">
          <div class="goods-panel-title">商品推荐</div>
          <button
            type="button"
            class="goods-panel-close"
            @click="goodsPanelVisible = false"
          >
            x
          </button>
        </div>

        <div v-if="goodsLoading" class="goods-empty">商品加载中...</div>

        <div v-else-if="goodsList.length" class="goods-list">
          <div
            v-for="item in goodsList"
            :key="item.goodsId || item.id"
            class="goods-card"
            @click="handleGoodsClick(item)"
          >
            <div class="goods-image-wrap">
              <img
                :src="getGoodsImage(item.coverImage)"
                :alt="item.goodsName"
                class="goods-image"
              >
            </div>
            <div class="goods-info">
              <div class="goods-name">{{ item.goodsName || '--' }}</div>
              <div class="goods-price-row">
                <span class="goods-price">￥{{ formatPrice(item.memberPrice || item.price) }}</span>
                <span
                  v-if="item.linePrice && Number(item.linePrice) !== Number(item.memberPrice || item.price)"
                  class="goods-line-price"
                >
                  ￥{{ formatPrice(item.linePrice) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="goods-empty">暂无推荐商品</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCodeProjectCg, getRecommendationListByRecord } from '@/api/signUp'
export default {
  name: 'IndexView',
  computed: {
    goodsImageBaseUrl() {
      return (process.env.VUE_IMG_URL || 'https://cos.dexintangjiankang.cn').replace(/\/$/, '')
    }
  },
  data() {
    return {
      id: '',
      iframeOne: '',
      iframeTwo: '',
      type: '1',
      goodsLoading: false,
      goodsList: [],
      goodsPanelVisible: false
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    toggleGoodsPanel() {
      this.goodsPanelVisible = !this.goodsPanelVisible
    },
    fetchData(){
      console.log(this.$route.query.id)
      this.id = this.$route.query.id;
      this.getGoodsList(this.id)
      getCodeProjectCg({
        id: this.id
      }).then(res => {
        console.log(res)
        if (res.data.code == 200) {
            this.iframeOne = res.data.data.result1Simple
            if(res.data.data.result1Simple == '' || res.data.data.result1Simple == null){
             this.iframeOne = res.data.data.result2Simple
            }
            this.type = res.data.data.type
            if(res.data.data.type == 2 || res.data.data.type == 3){
            //获取当前的 host
            this.iframeTwo = "https://report.dexintangjiankang.cn/#/face?id=" + this.id
          }
        }
      })
     

     
    }
    ,
    getGoodsList(id) {
      if (!id) {
        this.goodsList = []
        return
      }
      this.goodsLoading = true
      getRecommendationListByRecord(Number(id), {
        silentError: true
      }).then(res => {
        if (String(res.data.code) === '200') {
          const data = res.data.data
          this.goodsList = Array.isArray(data) ? data : []
        } else {
          this.goodsList = []
        }
      }).catch(() => {
        this.goodsList = []
      }).finally(() => {
        this.goodsLoading = false
      })
    },
    formatPrice(price) {
      const num = Number(price)
      if (Number.isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    getGoodsImage(url) {
      if (!url) {
        return ''
      }
      const imageUrl = String(url).trim()
      if (/^(https?:)?\/\//i.test(imageUrl) || imageUrl.startsWith('data:')) {
        return imageUrl
      }
      return `${this.goodsImageBaseUrl}/${imageUrl.replace(/^\/+/, '')}`
    },
    handleGoodsClick(item) {
      const goodsId = item && (item.goodsId || item.id)
      if (!goodsId) {
        return
      }
      if (window.wx && window.wx.miniProgram && typeof window.wx.miniProgram.navigateTo === 'function') {
        window.wx.miniProgram.navigateTo({
          url: `/pages/goods-detail/goods-detail?id=${goodsId}`
        })
        return
      }
      if (this.$message && typeof this.$message.warning === 'function') {
        this.$message.warning('请在微信环境中打开商品详情')
      }
    }
  }
}
</script>

<style scoped>
.iframe-page {
  height: 100vh;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  -webkit-overflow-scrolling: touch;
}

.panel {
  height: 100vh;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.goods-float-button {
  position: fixed;
  left: 24px;
  bottom: 24px;
  z-index: 1000;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #ff7a45, #ff4d4f);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  box-shadow: 0 10px 24px rgba(255, 77, 79, 0.28);
  cursor: pointer;
}

.goods-float-count {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.22);
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.goods-panel-mask {
  position: fixed;
  inset: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.32);
}

.goods-panel {
  position: absolute;
  left: 24px;
  bottom: 84px;
  width: 360px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 120px);
  padding: 18px 16px 10px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.16);
  overflow: hidden;
}

.goods-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.goods-panel-title {
  font-size: 18px;
  font-weight: 600;
  color: #23201e;
}

.goods-panel-close {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: #f5f5f5;
  color: #666;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}

.goods-list {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.goods-card {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  cursor: pointer;
}

.goods-card + .goods-card {
  border-top: 1px solid #f0f0f0;
}

.goods-image-wrap {
  width: 88px;
  height: 88px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #f1ece6;
}

.goods-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.goods-info {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.goods-name {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
  color: #23201e;
  word-break: break-word;
}

.goods-price-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 10px;
}

.goods-price {
  font-size: 20px;
  font-weight: 700;
  color: #b9413b;
}

.goods-line-price {
  font-size: 13px;
  color: #a59b90;
  text-decoration: line-through;
}

.goods-empty {
  padding: 28px 0;
  text-align: center;
  font-size: 14px;
  color: #8b847b;
}

@media (max-width: 768px) {
  .goods-float-button {
    left: 16px;
    bottom: 16px;
  }

  .goods-panel {
    left: 16px;
    right: 16px;
    bottom: 72px;
    width: auto;
    max-width: none;
  }
}
</style>
